import { BoxBackgrounds } from '@components/atoms/Box/Box'

import { GridCard } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock GridCard
 * @param overrides - Partial fields to override defaults
 * @returns Complete GridCard mock
 */
export function createGridCard(overrides: Partial<GridCard> = {}): GridCard {
  return {
    _uid: '2ded3a15-933d-466b-a228-9e5fc65dcc9c',
    icon: createStoryblokAsset({
      id: 1234,
      alt: '1234',
      filename: 'https://a.storyblok.com/f/235453/1234/icon.png',
      src: 'https://a.storyblok.com/f/235453/1234/icon.png',
      width: 100,
      height: 100,
      aspect_ratio: 1,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    text: createStoryblokRichtext(''),
    label: '',
    button: [],
    component: 'grid-card',
    background_color: BoxBackgrounds.PRIMARY,
    _editable:
      '<!--#storyblok#{"name": "grid-card", "space": "235453", "uid": "2ded3a15-933d-466b-a228-9e5fc65dcc9c", "id": "322564270"}-->',
    ...overrides,
  }
}
